import React from 'react';
import { Card, Button } from 'react-bootstrap';
import '../assets/styles/JobCard.css'; // Make sure to import the CSS file

const JobCard = ({ job }) => {
  return (
    <Card className="mb-4 job-card">
      <Card.Body className="d-flex flex-column">
        <div className="job-details">
          <Card.Title>{job.title}</Card.Title>
          <Card.Subtitle className="mb-2 text-muted">{job.company}</Card.Subtitle>
          <Card.Text>
            <strong>Location:</strong> {job.location}
          </Card.Text>
          <Card.Text>
            <strong>Salary:</strong> {job.salary}
          </Card.Text>
          <Card.Text>{job.description}</Card.Text>
        </div>
        <div className="button-container">
          <Button variant="primary">Apply Now</Button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default JobCard;
